define('modules/item_image/image_player/image_player_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/button/button_view',

  'text!./image_player_template.html'
], function (Backbone, $, _, session,
             ButtonView,
             player_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      // Make sure possible external close-functions will be used instead of the built in.
      this.delegateEvents();

      this.render();
      this.orientation = 0;
      this.previousOrientation = -1;
      this.fitHeight = this.fitHeight || 400;
      this.previewImage();
    },

    orientations: [],
    image: null,

    className: 'image-player',
    subViews: [],
    template: _.template(player_template),

    events: {
      'click .close': 'close',
      'click .js-toggle-size': 'toggleSize',
      'click .js-add-button a': 'setOrientation',
      'click .js-replay': 'replay'
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    previewImage: function () {
      var self = this;
      this.img = document.createElement('img');
      this.img.src = _.media_url(this.model.get('preview'));

      this.$('.js-image-player-container').html(this.img);
    },

    close: function () {
      if(this.onClose) {
        this.onClose();
      }
      this.remove();
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }

  });
  return View;
});

